import * as _ from 'lodash';
import * as log from 'loglevel';
import * as api from './api';
import * as FullCalendar from 'fullcalendar';
import qs from 'qs';
import {
  CookieCollection,
  getUrlParameter,
  Log,
  modalalert,
  TIME_ZONE_OFFSET,
  TIME_ZONE_PREDEFINED,
  updateHeaderPrice
} from './script';
import {
  AjaxScheduleResult,
  CustomEventCollectionItem,
  DatesDisplay,
  HeroEvent,
  Pax,
  FullCalendarView,
  DatePricing,
  ProductPricingMulti
} from './models';
// @ts-ignore
import moment from 'moment';
import { ajax_call_async } from './h';

// tslint:disable-next-line:class-name
interface window {
  customPopUp: (el) => void;
}

const FORMAT_CALENDAR_DATE = 'YYYY-MM-DD';
const FORMAT_HERO_EVENT_DATE = 'YYYY-MM-DD';
const FORMAT_AJAX_DATE = 'YYYYMMDD';
const TEXT_CHECK_AVAILABILITY_SELECT_ARRIVAL_DATE =
  'Click to select your arrival date';
const TEXT_DEPARTURE_ONLY = 'Departure Only';
const TEXT_DEPARTURE = 'Departure';
const TEXT_CHECKIN = 'Arrival';

/* Remember to change CSS class name as well */
const CLASS_NAME_FC_PART_OF_TRIP = 'fc-part-of-trip';
const CLASS_NAME_DEPARTURE_ONLY = 'departure-only';
const CLASS_NAME_FC_CUSTOM_EVENT = 'fc-custom-event';
const CLASS_NAME_CHECK_IN = 'check-in';
const CLASS_NAME_CHECK_OUT = 'check-out';
const CLASS_NAME_CUSTOM_EVENT = 'customevent';

const PART_OF_TRIP_RE = new RegExp(CLASS_NAME_FC_PART_OF_TRIP);
const CHECK_IN_RE = new RegExp('checkin', 'i');
const CHECK_OUT_RE = new RegExp('checkout', 'i');

const TEMPLATE_CUSTOM_EVENT = _.template(
  '<span class="' +
    CLASS_NAME_FC_CUSTOM_EVENT +
    '" style="background-color: <%- backgroundColor %>;" onclick="MainScript.customPopUp(this)" data-item-id="<%- itemId %>"><img alt="<%- imgAlt %>" src="<%- imgSrc %>" /></div>'
);

export function customPopUp(el) {
  const $el = $(el);
  const modalclass = '#modal' + $el.data('item-id');
  $(modalclass).modal('show');
}

export function fixTimezoneOffset(dt: moment.Moment) {
  let d = moment(dt); // clone Moment object
  d = d.utcOffset(TIME_ZONE_OFFSET);
  d = d.hour(0);
  d = d.minute(0);
  d = d.second(0);
  d = d.millisecond(0);
  return d;
}

export function datePricingReduceByLowestTotalRrp(
  previous: DatePricing[],
  current: DatePricing
) {
  const index = _.findIndex(
    previous,
    (x) => x.dateCheckIn === current.dateCheckIn
  );
  if (index >= 0) {
    const found = previous[index];
    // replace if current date pricing is lower than found date pricing
    console.log(found.totalRrp, current.totalRrp);
    if (previous[index] && found.totalRrp > current.totalRrp) {
      previous.splice(index, 1);
      previous.push(current);
    }
  } else {
    // add to array if not found
    previous.push(current);
  }
  return previous;
}

export function populateDepartureOnlyEvents(events: HeroEvent[]): HeroEvent[] {
  const firstEvent = _.minBy(events, (e) => e.start.unix());
  const lastEvent = _.maxBy(events, (e) => e.start.unix());
  if (!firstEvent || !lastEvent) {
    return events;
  }

  const currentDate = moment(firstEvent.start);
  // add extra day, for last departure day
  const lastDate = moment(lastEvent.start).add(1, 'day');

  if (lastDate.diff(currentDate, 'minutes') <= 0) {
    log.error('current date is less than or equal to last date');
    return events;
  }

  let isEventContinuous = false;
  while (lastDate.diff(currentDate, 'minutes') >= 0) {
    const event = _.find(
      events,
      (e) => e.start.diff(currentDate, 'minutes') === 0
    );
    if (event) {
      isEventContinuous = true;
    } else {
      if (isEventContinuous) {
        const event: HeroEvent = {
          defaultTitle: TEXT_DEPARTURE_ONLY,
          title: TEXT_DEPARTURE_ONLY,
          start: moment(currentDate),
          allDay: true,
          className: CLASS_NAME_DEPARTURE_ONLY,
          eventType: 'DepartureOnly',
          rrp: 0,
        };
        events.push(event);
        log.debug('added depature only date', event.start.format('YYYY-MM-DD'));

        isEventContinuous = false;
      }
    }
    currentDate.add(1, 'day'); // Note: changes the date of object, not a functional method
  }

  return events;
}

export function mapToHeroEvents(
  datePricing: DatePricing[],
  numberOfRoomsRequired: number
): HeroEvent[] {
  return datePricing
    .filter((d) => {
      // skip if no availability
      if (d.availability === 0) {
        log.debug('no availability', d.dateCheckIn);
        return false;
      }

      if (d.availability < numberOfRoomsRequired) {
        log.debug(
          'availability is less than numberOfRoomsRequired',
          d.dateCheckIn,
          d.availability
        );
        return false;
      }

      if (d.rrp <= 0) {
        log.debug('rrp is less than or equal to 0', d.rrp);
        return false;
      }

      return true;
    })
    .reduce(datePricingReduceByLowestTotalRrp, [] as DatePricing[])
    .map(
      (datePricing): HeroEvent => {
        // title is displayed on each calendar day
        const showPricesOnCalendar = Boolean($('#showPricesOnCalendar').val());

        const discountCookie = CookieCollection.DiscCookie.get();
        var discount = 0;
        var discountCallOut = '';
        if (discountCookie)
        {
          console.log('discount: ',discountCookie.code);
          console.log('dates', discountCookie.dates);
          // discountCookie.dates.forEach(function (dateRange) {
          //   var dateToCheck = moment(datePricing.dateCheckIn);
          //   var dateFrom = moment(dateRange.validFrom.date.split('+')[0]);
          //   var dateTo = moment(dateRange.validTo.date.split('+')[0]);
          var dateToCheck = moment(datePricing.dateCheckIn);
          var range = discountCookie.dates.split('|');
          range.forEach(function (dateRange) {
            if (dateRange.length > 4)
            {
              var dateFrom = moment(dateRange.split('^')[0]);
              var dateTo = moment(dateRange.split('^')[1]);
              if (dateToCheck.isBetween(dateFrom,dateTo, undefined, '[]'))  
              {
                discount = discountCookie.per;
                discountCallOut = (discountCookie.callOutText).replace( /\+/g, ' ' );
              }
            }
          });          
        }

        const title = showPricesOnCalendar ? (discount > 0 ? '<span class="discount">' + discountCallOut + '</span><br />From <span class=\"strikediag\">$' + datePricing.totalRrp + '</span> $' + (datePricing.totalRrp - (datePricing.totalRrp * discount/100)).toFixed(2) : 'From $' + datePricing.totalRrp ) : 'Available';
        return {
          id: undefined,
          productId: datePricing.productId,
          rateCode: datePricing.rateCode,
          defaultTitle: title,
          title: title,
          start: moment(datePricing.dateCheckIn),
          className: '',
          allDay: true,
          itemId: undefined,
          availability: datePricing.availability,
          eventType: 'Normal',
          rrp: discount > 0 ? (datePricing.totalRrp - (datePricing.totalRrp * discount/100)) : datePricing.totalRrp
        };
      }
    )
    .sort((a: HeroEvent, b: HeroEvent) => {
      return a.start.diff(b.start);
    });
}

export class CheckAvailability {
  private heroEvents: HeroEvent[] = [];
  private customEvents: CustomEventCollectionItem[] = [];
  private paxs: Pax[] = [];
  private checkIn?: moment.Moment;
  private checkOut?: moment.Moment;
  private $calender: JQuery;

  constructor($calendar) {
    this.$calender = $calendar;
  }

  renderCalendar = () => {
    const $calendar = $('#calendar');

    $calendar.fullCalendar('removeEvents');
    $('td').removeClass('dayWithEvent');   
    $calendar.fullCalendar('addEventSource', this.heroEvents);

    $('#loader').removeClass('show');
  };

  getProductPricingMultiSuccess = (
    numberOfRoomsRequired: number,
    schedule: ProductPricingMulti
  ) => {
    Log.group('productPriceMultiAjaxCallSuccess');

    log.debug('ajax_call_async schedule', schedule);

    // reset hero events array
    this.heroEvents = [];

    try {
      if (!schedule || !schedule.datePricing) {
        log.error('schedule or schedule.datePricing should not be undefined');
        return;
      }

      const tmpHeroEvents: HeroEvent[] = mapToHeroEvents(
        schedule.datePricing,
        numberOfRoomsRequired
      );
      this.heroEvents = populateDepartureOnlyEvents(tmpHeroEvents);
      log.debug('heroEvents', this.heroEvents);
      this.renderCalendar();
      
      //if dates passed in then select them
      if (CookieCollection.Dates != null)
      {
        if (CookieCollection.Dates.get()?.checkIn != null)
        {
          log.debug('checkIn:',CookieCollection.Dates.get()?.checkIn as string);
          this.addCheckIn(moment(CookieCollection.Dates.get()?.checkIn as string));
        }
        if (CookieCollection.Dates.get()?.checkIn != null)
        {
          this.addCheckOut(moment(CookieCollection.Dates.get()?.checkIn as string), moment(CookieCollection.Dates.get()?.checkOut as string));
        }
      }
      
      
    } finally {
      Log.groupEnd();
      $('button.fc-next-button').removeClass('fc-state-disabled');
    }
  };

  private updateCal = (start: string, end: string, productId: number, promoCode: string) => {
    Log.group('updateCal');
    try {
      log.debug('start', start);
      log.debug('end', end);
      log.debug('productId', productId);
      if (promoCode == 'undefined')
      {
        promoCode = '';
      }
      log.debug('promoCode', promoCode);

      if (!this.paxs) {
        log.error('paxs should not be undefined');
        return;
      }

      if (this.paxs.length === 0) {
        log.warn('no paxs defined');
      }

      $('#loader').addClass('show');

      // note: room starts from 1
      let numberOfRoomsRequired = 0;
      if (this.paxs.length > 0) {
        const maxPaxByRoom = _.maxBy(this.paxs, (pax) => pax.room);
        if (!maxPaxByRoom) {
          log.error('cannot obtain max room number from paxArray');
          return;
        }
        numberOfRoomsRequired = maxPaxByRoom.room;
      }

      $('button.fc-next-button').addClass('fc-state-disabled');

      // set start date to 1 day (Sat) ahead for week view not showing departure only issue
      const mStart = moment(start, 'YYYY-MM-DD');
      const siteId = Number($('#siteId').val());      
      start = mStart.subtract(1, 'day').format('YYYY-MM-DD');
      api
        .getProductPricingMulti(productId, siteId, start, end, this.paxs, promoCode, '', true)
        .then((response) => {
          this.getProductPricingMultiSuccess(
            numberOfRoomsRequired,
            response.data
          );
        })
        .catch((error) => {
          console.error('getProductPricingMulti', error);
          $('button.fc-next-button').removeClass('fc-state-disabled');
        });
    } finally {
      Log.groupEnd();
    }
  };

  /**
   * initialise calendar control
   *
   * @param {number} productId
   */
  private initialiseCalendar = (productId, promoCode) => {
    if (this.$calender.length) {
      // custom webapp events   
      const siteId = Number($('#siteId').val());       
      $.getJSON('/custom-events?json=true&site=' + siteId, (result) => {
        result.items
          .forEach((item) => {
            this.customEvents.push(
              ...item.dates
                .filter((date) => date.isActive)
                .map((date) => ({
                  ...item,
                  'Day': date.date,
                  'DayEnd': date.date,
                  'Colour': item.colour,
                  'Feature Image': item.featuredImage
                }))
            );
          });
      });
    }

    $('#cleardatesModal').on('click', () => {
      this.checkIn = undefined;
      this.checkOut = undefined;
      CookieCollection.DatesDisplay.remove();
      CookieCollection.SelectedRooms.remove();
      CookieCollection.PriceDisplay.remove();
      this.updateCalendarUI();
      window.location.replace('./check-availability');
    });

    $('#clearDates').on('click', this.onCheckAvailabilityClearDatesClick);

    // Initialise Calendar and bind callbacks

    const FULL_CALENDAR_TIME_ZONE = 'UTC';
    const FULL_CALENDAR_LIST_WEEK_VIEW = 'listWeek';
    const FULL_CALENDAR_MONTH_VIEW = 'month';
    const MOBILE_MAX_WIDTH = 990;

    // noinspection JSCheckFunctionSignatures
    const $window = $(window);
    const windowWidth = $window.width() || 0;
    const isMobile = windowWidth < MOBILE_MAX_WIDTH;

    const fullCalendarDefaultView = isMobile
      ? FULL_CALENDAR_LIST_WEEK_VIEW
      : FULL_CALENDAR_MONTH_VIEW;

    const listDayAltFormat = isMobile ? 'Do MMM' : 'MMMM D, YYYY';

    const height = isMobile ? 400 : 'parent';

    // noinspection JSUnusedLocalSymbols
    const defaultDate = moment(new Date(getUrlParameter('k') || new Date())).tz(
      TIME_ZONE_PREDEFINED
    );
    log.debug('defaultDate', defaultDate.toString());

    const fullCalendarConfig = {
      defaultDate: defaultDate,
      defaultView: fullCalendarDefaultView,
      height: height,
      timeFormat: 'h:mm a',
      timezone: FULL_CALENDAR_TIME_ZONE,
      ignoreTimezone: false,
      eventLimit: true,
      selectable: false,
      selectMinDistance: 1,
      eventOrder: 'start',
      handleWindowResize: true,
      listDayAltFormat: listDayAltFormat,

      select: (startDate, endDate) => {
        log.debug('fullcCalendarConfig', startDate, endDate);
      },

      /**
       * Called when event is clicked
       *
       * @param {HeroEvent} calEvent
       * @param {JQueryEventObject} jsEvent
       * @param {FullCalendarView} view
       */
      eventClick: (calEvent, jsEvent, view) => {
        Log.group('eventClick');
        this.updateCalendar(calEvent.start, jsEvent, view);
        Log.groupEnd();
      },

      /**
       * Called when day
       *
       * @param {Moment} date
       * @param {Object} jsEvent
       * @param {Object} view
       * @param {Object} resourceObj
       */
      dayClick: (date, jsEvent, view, resourceObj) => {
        Log.group('dayClick');
        this.updateCalendar(date, jsEvent, view);
        Log.groupEnd();
      },

      /**
       *
       * @param {HeroEvent} event
       * @param {JQuery} anchorElement
       * @param {FullCalendarView} view
       */
    
      /**
       * Handle event after all render callback from FullCalendar
       */
      eventAfterAllRender: (view: FullCalendarView) => {
        Log.group('eventAfterAllRender');
        try {
          // $('.fc-custom-event').remove();
          
          log.debug(this.customEvents);
          
          // add custom event items
          _.forEach(this.customEvents, (customEvent) => {
            const start = fixTimezoneOffset(moment(customEvent.Day));

            // check event and availability, if no event or availability on custom event date, do not should icon
            const heroEvent = _.find(this.heroEvents, (event) => {
              return event.start.diff(start, 'day') === 0;
            });
            if (!heroEvent) {
              log.debug('hero event not found');
              return;
            }
            if (heroEvent.availability === 0) {
              log.debug('no availability');
              return;
            }
            const startDate = start.format(FORMAT_HERO_EVENT_DATE);
            
            log.debug('Custom Event:', startDate);

            const selector =
              view.type === FULL_CALENDAR_LIST_WEEK_VIEW
                ? `tr.fc-list-item[data-date='${startDate}'] > td.fc-list-item-title`
                : `td.fc-day-top[data-date='${startDate}']`;

            // return if custom event is already added
            if ($(selector + ' .' + CLASS_NAME_FC_CUSTOM_EVENT).length > 0) {
              return;
            }
            const html = TEMPLATE_CUSTOM_EVENT({
              itemId: customEvent.itemId,
              backgroundColor: customEvent.Colour,
              imgAlt: 'customEvent',
              imgSrc: '/assets/img/pawprint.png'
            });

            // if (view.type === FULL_CALENDAR_LIST_WEEK_VIEW) {
            //   var orgHtml = $(selector).html();
            //   $(selector).empty();
            //   $(selector).append(html);
            //   $(selector).append(orgHtml);
            // } else {
            $(selector).append(html);
            // }
          });

          switch (view.type) {
            case 'month':
              break;
            case 'listWeek':
              if (this.checkIn) {
                const $heading = $(
                  `tr.fc-list-heading[data-date=${this.checkIn.format(
                    FORMAT_CALENDAR_DATE
                  )}]`
                );
                $heading.addClass('checkin');
                $heading.next('.fc-list-item').addClass('checkin');
              }
              if (this.checkOut) {
                $(
                  'tr.fc-list-heading[data-date=' +
                    this.checkOut.format(FORMAT_CALENDAR_DATE) +
                    ']'
                ).addClass('checkout');
              }
              // apply fc-part-of-trip style to fc-list-headers
              $('tr.fc-list-item.' + CLASS_NAME_FC_PART_OF_TRIP).each(
                (index, el) => {
                  const $el = $(el);
                  const $headings = $(
                    'tr.fc-list-heading[data-date=' + $el.data('date') + ']'
                  );
                  log.debug($headings.length);
                  $headings.addClass(CLASS_NAME_FC_PART_OF_TRIP);
                }
              );

              break;
            default:
              log.warn('view.type not supported', view.type);
              break;
          }
        } finally {
          Log.groupEnd();
        }
      },

      viewRender: (view: FullCalendarView, element) => {
        const start = view.start.format(FORMAT_CALENDAR_DATE);
        const end = view.end.format(FORMAT_CALENDAR_DATE);
        this.updateCal(start, end, productId, promoCode);
      }
    };

    if (fullCalendarDefaultView === FULL_CALENDAR_LIST_WEEK_VIEW) {
      _.assign(fullCalendarConfig, {
        noEventsMessage:
          'Sorry, no events available\r\n\r\nPlease click the arrow to try next week',
        
      });
    }

    //enable HTML titles
    _.assign(fullCalendarConfig, {
      eventRender: function(eventObj, $el, view) {
        var title = $el.find( '.fc-title, .fc-list-item-title');    
      	title.html( title.text() );

        const date = eventObj.start.format(FORMAT_CALENDAR_DATE);
        switch (view.type) {
          case 'month':
            // set event as day with event
            $('td[data-date=\'' + date + '\']').addClass('dayWithEvent');

            if (eventObj.eventType === 'DepartureOnly') {
              $('td.fc-day[data-date=\'' + date + '\']').addClass(
                CLASS_NAME_DEPARTURE_ONLY
              );
            }
            break;
          case 'listWeek':
            $el.attr('data-date', date);

            break;
          default:
            log.warn('view.type not supported', view.type);
            break;
        }
    }});

    
    // @ts-ignore
    const calendar = this.$calender.fullCalendar(fullCalendarConfig);
    if (calendar.fullCalendar('option', 'timezone') !== TIME_ZONE_PREDEFINED) {
      log.error('fullCalendar timezone should set to TIME_ZONE_PREDEFINED');
    }
    if (calendar.fullCalendar('option', 'ignoreTimezone') !== false) {
      log.error('fullCalendar ignoreTimezone should be false');
    }
    const widgetStart = getUrlParameter('wstart');
    if (widgetStart) {
      $('#calendar').fullCalendar(
        'gotoDate',
        moment(widgetStart, FORMAT_CALENDAR_DATE).tz(TIME_ZONE_PREDEFINED)
      );
    }

    // Update UI
    this.updateCalendarUI();
  };

  public initialise = () => {
    const existingstart = getUrlParameter('s');

    // if (existingstart) {
    //   $('#removeDates').modal('show');
    // }

    if (getUrlParameter('k') && getUrlParameter('f') === '0') {
      var myProductSearch = CookieCollection.ProductSearch.get();
      const discountSearch = CookieCollection.DiscCookie.get();
      if (discountSearch)
      {
        if (discountSearch.code != '')
        {
          myProductSearch!.promoCode = '';
          CookieCollection.ProductSearch.set(myProductSearch!);
        }
      }
      
      const nights = Number(getUrlParameter('n') || 1);
      const checkIn = moment(getUrlParameter('k')).tz(TIME_ZONE_PREDEFINED);
      const checkOut = moment(getUrlParameter('k'))
        .tz(TIME_ZONE_PREDEFINED)
        .add(nights, 'days');

      CookieCollection.DatesDisplay.set({
        dates: [
          checkIn.format('DD MMM'),
          checkOut.format('DD MMM'),
          checkIn.format('DD MMM YYYY'),
          checkOut.format('DD MMM YYYY')
        ]
      });

      window.location.href = `./select-room?${qs.stringify({
        s: checkIn.format('YYYY-MM-DD'),
        e: checkOut.format('YYYY-MM-DD'),
        branch: myProductSearch!.branchId,
        rc: 1,
        promoCode: myProductSearch!.promoCode,
        roommax: 1 // myProductSearch!.paxs || []
      })}`;
      return;
    }


    // Get Array, put first item as prod ID, pass array to calendar
    var productSearch = CookieCollection.ProductSearch.get();
    const discountSearch = CookieCollection.DiscCookie.get();
    if (discountSearch)
    {
      if (discountSearch.code != '')
      {
        productSearch!.promoCode = '';
        CookieCollection.ProductSearch.set(productSearch!);
      }
    }


    if (!productSearch) {
      log.error('productSearch is undefined');
      return;
    }
    if (!productSearch.branchId) {
      log.error('productSearch.branchId is undefined');
      return;
    }
    var promoCode = productSearch.promoCode;
    
    this.paxs = !productSearch || !productSearch.paxs ? [] : productSearch.paxs;

    const rooms: number[] = [];

    for (let i = 0; i < this.paxs.length; i++) {
      rooms.push(this.paxs[i].room);
    }

    const roomCount = _.reduce(rooms, (a, b) => Math.max(a, b));

    this.initialiseCalendar(productSearch.branchId, productSearch.promoCode);

    // apply click handler to 'Previous' button
    $('#backbtn').attr('href', './accommodation');

    // apply click handler to 'Continue' button
    $('#RoomChooser').on('click', () => {
      if (this.checkIn && this.checkOut) {
        const start = this.checkIn;
        const end = this.checkOut;
        const myProductSearch = CookieCollection.ProductSearch.get();
        if (!myProductSearch) {
          log.error('cookie productsearch not defined');
          return;
        }
        const branchId = myProductSearch.branchId;

        const dates: string[] = [];
        dates.push(start.format('DD MMM'));
        dates.push(end.format('DD MMM'));
        dates.push(start.format('DD MMM YYYY'));
        dates.push(end.format('DD MMM YYYY'));
        CookieCollection.DatesDisplay.set({ dates: dates });

        window.location.href = `./select-room?s=${start.format(
          'YYYY-MM-DD'
        )}&e=${end.format(
          'YYYY-MM-DD'
        )}&branch=${branchId}&promoCode=${promoCode}&rc=1&roommax=${roomCount}`;
      } else {
        modalalert(
          'Please select an arrival and departure date to continue.',
          'error',
          false
        );
      }
    });
  };

  public getHeroEvents = () => this.heroEvents;

  /**
   * find index of hero event with class name contains CLASS_NAME_FC_PART_OF_TRIP
   */
  private findIndexOfHeroEventWithFcPartOfTripClassName = (
    events: HeroEvent[]
  ) => {
    return _.findIndex(
      events,
      (value) => value.className.indexOf(CLASS_NAME_FC_PART_OF_TRIP) >= 0
    );
  };

  /**
   * reset hero events class name to default value
   */
  private resetHeroEventsClassNames = (events) => {
    let index;
    let event;
    let j;

    // remove class name with fc-part-of-trip
    while (
      (index = this.findIndexOfHeroEventWithFcPartOfTripClassName(events)) >= 0
    ) {
      event = events[index];
      event = _.assign(event, {
        className: _.replace(event.className, PART_OF_TRIP_RE, '')
      });
      events[index] = event;
    }

    // find any events marked as class check in, remove the class.
    for (j = 0; j < events.length; j++) {
      event = events[j];
      if (CHECK_IN_RE.test(event.className)) {
        events[j] = _.assign(event, {
          className: _.replace(event.className, CHECK_IN_RE, '')
        });
      }
    }

    // reset title of checkin item
    for (j = 0; j < events.length; j++) {
      if (events[j].title === TEXT_CHECKIN) {
        events[j] = _.assign(events[j], { title: events[j].defaultTitle });
      }
    }

    // remove class name checkout
    for (j = 0; j < events.length; j++) {
      event = events[j];
      if (CHECK_OUT_RE.test(event.className)) {
        events[j] = _.assign(event, {
          className: _.replace(event.className, CHECK_OUT_RE, '')
        });
      }
    }

    // reset title of departure item
    for (j = 0; j < events.length; j++) {
      if (events[j].title === TEXT_DEPARTURE) {
        events[j] = _.assign(events[j], { title: events[j].defaultTitle });
      }
    }

    return events;
  };

  /**
   * Reset header price
   */
  private resetHeaderPrice = () => {
    CookieCollection.PriceDisplay.remove();
    updateHeaderPrice();
  };

  /**
   * Reset calender
   */
  private resetCalender = (events) => {
    this.resetHeaderPrice();

    this.checkIn = undefined;
    this.checkOut = undefined;
    $('td').removeClass('checkoutdaywrapper');
    CookieCollection.DatesDisplay.remove();

    events = this.resetHeroEventsClassNames(events);

    // find any events marked as class checkout holder, remove them.
    // for (j = 0; j < events.length; j++) {
    //   className = events[j].className;
    //   if (className.indexOf(CLASS_NAME_DEPARTURE_ONLY) > 0) {
    //     events.splice(j, 1);
    //   }
    // }

    return events;
  };

  /**
   * Clear selected dates
   */
  private checkAvailabilityWipeDates = (events) => {
    log.debug('checkAvailabilityWipeDates');

    events = this.resetCalender(events);

   

    return events;
  };

  /**
   * Update header 'Dates of stay' value
   */
  private updateCalendarDisplayedDates = () => {
    const $calendar = $('#calendar');
    // var checkin = $('#checkindate').val();
    // var checkout = $('#checkoutdate').val();
    $('#datesofStay > span').hide();
    $('#datesofStay em').show();
    const a = this.checkIn;
    const b = this.checkOut;
    const nights = b ? b.diff(a, 'days') : 0;

    if (this.checkIn) {
      $('.checkindatedisplay').text(this.checkIn.format('D MMM'));
      $('h1').text('CHECK OUT');
      $('#nightscount').text('');
    } else {
      $('.checkindatedisplay').text('');
      $('h1').text('CHECK IN');
      $('#nightscount').text('');
    }

    if (this.checkOut) {
      $('.checkoutdatedisplay').text(this.checkOut.format('D MMM'));
      $('h1').text('Click continue to select your room/s');
      if (nights === 1) {
        $('#nightscount').text(nights + ' Night');
      } else {
        $('#nightscount').text(nights + ' Nights');
      }
    } else {
      $('.checkoutdatedisplay').text('');
      $('#nightscount').text('');
    }

    $calendar.fullCalendar('removeEvents');
    $('td').removeClass('dayWithEvent');
    $calendar.fullCalendar('addEventSource', this.heroEvents);
    // $calendar.fullCalendar('addEventSource', customEvents);
  };

  /**
   * Update continue button properties
   */
  private updateCalendarContinueButton = () => {
    // var checkin = $('#checkindate').val();
    // var checkout = $('#checkoutdate').val();
    const $continueButton = $('a#RoomChooser');

    if (this.checkIn && this.checkOut) {
      $continueButton.removeClass('disabled');
    } else {
      $continueButton.addClass('disabled');
    }
  };

  /**
   *
   */
  private updateCalendarUI = () => {
    this.updateCalendarDisplayedDates();
    this.updateCalendarContinueButton();
  };

  private onCheckAvailabilityClearDatesClick = (e: JQuery.Event) => {
    e.preventDefault();

    this.heroEvents = this.resetCalender(this.heroEvents);
    this.updateCalendarUI();

    const $calendar = $('#calendar');
    $calendar.fullCalendar('removeEvents');
    $('td').removeClass('dayWithEvent');
    $calendar.fullCalendar('addEventSource', this.heroEvents);
    // $calendar.fullCalendar('addEventSource', customEvents);

    $('.checkindatedisplay').text('');
    $('.checkoutdatedisplay').text('');
    $('#nightscount').text('');
    $('h1').text(TEXT_CHECK_AVAILABILITY_SELECT_ARRIVAL_DATE);
    modalalert('Dates have been cleared', 'success', false);
  };

  /**
   * Logic to display check in / 'Arrival' date on calendar
   *
   * @param {Moment} date
   */
  private addCheckIn = (date) => {
    Log.group('addCheckIn');
    try {
      this.heroEvents = this.checkAvailabilityWipeDates(this.heroEvents);
      const index = _.findIndex(
        this.heroEvents,
        (e) =>
          e.start.format(FORMAT_CALENDAR_DATE) ===
          date.format(FORMAT_CALENDAR_DATE)
      );
      if (index < 0) {
        return;
      }
      const event = this.heroEvents[index];
      log.debug('event.eventType', event.eventType);
      log.debug('event.start', event.start.toString());
      log.debug('date', date.toString());
      if (event.eventType === 'DepartureOnly') {
        return;
      }

      this.heroEvents[index] = _.assign(event, {
        title: TEXT_CHECKIN,
        className: event.className + ' checkin'
      });

      this.checkIn = date;
      this.updateCalendarUI();
      this.renderCalendar();
    } finally {
      Log.groupEnd();
    }
  };

  /**
   * Event called after check out date selected
   *
   * @param {Moment} arrivalDate
   * @param {Moment} departureDate
   */
  private addCheckOut = (arrivalDate, departureDate) => {
    Log.group('addCheckOut');
    try {
      if (!this.checkIn) {
        log.error('checkInDate should be an valid date string');
        return;
      }
      log.debug('arrivalDate', arrivalDate.toString());
      log.debug('departureDate', departureDate.toString());
      log.debug('checkIn', this.checkIn.toString());

      // Check if requested check out is prior to check in
      log.debug(
        'departureDate - checkIn minutes',
        departureDate.diff(this.checkIn, 'minutes')
      );
      log.debug(
        'departureDate - checkIn days',
        departureDate.diff(this.checkIn, 'days')
      );

      if (departureDate.diff(this.checkIn, 'minutes') <= 0) {
        log.warn(
          'addCheckOut: date is same or before checkInDate. Skip and move check in date'
        );
        // Date is earlier than check in, add to check in and wipe existing
        this.heroEvents = this.checkAvailabilityWipeDates(this.heroEvents);
        this.addCheckIn(departureDate);
        return;
      }

      // check if days between dates have availability
      let price = 0;

      let areAllDaysValid = true;
      log.debug('arrivalDate', arrivalDate.toString());
      let currentDate = moment(arrivalDate); // clone of start date

      while (areAllDaysValid && currentDate < departureDate) {
        const currentHeroEventIndex = _.findIndex(
          this.heroEvents,
          (x) => x.start.diff(currentDate, 'minutes') === 0
        );
        if (
          currentHeroEventIndex < 0 ||
          currentHeroEventIndex > this.heroEvents.length
        ) {
          log.warn('not found or out of range');
          // not found or out of range
          areAllDaysValid = false;
          break;
        }
        let currentHeroEvent = this.heroEvents[currentHeroEventIndex];
        log.debug('event rrp', currentHeroEvent.rrp);
        if (!currentHeroEvent) {
          log.warn('hero event not found');
          areAllDaysValid = false;
          break;
        // } else if (currentHeroEvent.title.indexOf('$') === -1) {
        } else if (currentHeroEvent.rrp === null || currentHeroEvent.rrp === 0) {
          areAllDaysValid = false;
          break;
        }

        // apply fc-part-of-trip style to date between arrival and departure
        if (currentDate > arrivalDate) {
          currentHeroEvent = _.assign(currentHeroEvent, {
            className:
              currentHeroEvent.className + ' ' + CLASS_NAME_FC_PART_OF_TRIP
          });
          this.heroEvents[currentHeroEventIndex] = currentHeroEvent;
        }

        // const priceStr = currentHeroEvent.title.replace('From $', '');
        // price += parseInt(priceStr);
        price += currentHeroEvent.rrp;

        currentDate = currentDate.add(1, 'day');
        log.debug('price', price, 'arrival', currentDate);
      }

      if (!areAllDaysValid) {
        modalalert('Sorry, these dates are unavailable.', 'error', false);
        this.heroEvents = this.checkAvailabilityWipeDates(this.heroEvents);
        return false;
      }

      let match = false;

      // mark checkout in green on desktop only
      // if (view !== "listView") {
      //
      // }

      // check if date exists to add checkout class
      for (let j = 0; j < this.heroEvents.length; j++) {
        const currentStart = this.heroEvents[j].start;
        if (currentStart.diff(departureDate, 'minutes') === 0) {
          match = true;
          this.heroEvents[j] = _.assign(this.heroEvents[j], {
            title: TEXT_DEPARTURE,
            className: this.heroEvents[j].className + ' checkout'
          });
          break;
        }
      }

      // Date is a valid check-out
      const $checkInDateTd = $(
        'td[data-date=\'' + arrivalDate.format('YYYY-MM-DD') + '\']'
      );
      $checkInDateTd.addClass('tripKeyDate');

      const $checkOutDateTd = $(
        'td[data-date=\'' + departureDate.format('YYYY-MM-DD') + '\']'
      );
      $checkOutDateTd.addClass('tripKeyDate').addClass('checkoutdaywrapper');

      log.debug('startDate', arrivalDate.toISOString());
      log.debug('endDate', departureDate.toISOString());
      currentDate = moment(arrivalDate).add(1, 'day');
      while (departureDate.diff(currentDate, 'minutes') > 0) {
        const heroEventDate = currentDate.format(FORMAT_HERO_EVENT_DATE);

        const $dayTd = $('td[data-date=\'' + heroEventDate + '\']');
        log.debug('$dayTd', heroEventDate, $dayTd.length);

        currentDate.add(1, 'day');
      }

      CookieCollection.PriceDisplay.set({ price: price });
      updateHeaderPrice();
      this.checkOut = departureDate;

      this.updateCalendarUI();
    } finally {
      Log.groupEnd();
    }
  };

  // noinspection JSUnusedLocalSymbols
  /**
   * @param {Moment} dateRaw - selected date, in UTC
   * @param {JQueryEventObject} jqEvent
   * @param {FullCalendarView} view
   */
  private updateCalendar = (dateRaw, jqEvent, view) => {
    Log.group('updateCalendar');
    try {
      const date = moment(dateRaw)
        .tz(TIME_ZONE_PREDEFINED)
        .subtract(TIME_ZONE_OFFSET, 'minutes'); // clone object
      if (date.hour() !== 0 || date.minute() !== 0 || date.second() !== 0) {
        log.error('hour and minute and second of date should be 0');
        return;
      }

      log.debug('date', date.toString());
      log.debug('checkIn', date.toString());
      // skip update event if custom event icon clicked
      const $target = $(jqEvent.target);
      if (
        $target.hasClass(CLASS_NAME_FC_CUSTOM_EVENT) ||
        $target.parent().hasClass(CLASS_NAME_FC_CUSTOM_EVENT)
      ) {
        return;
      }

      // If both dates filled
      if (this.checkIn && this.checkOut) {
        this.heroEvents = this.checkAvailabilityWipeDates(this.heroEvents);
        this.updateCalendarUI();
        this.addCheckIn(date);
      }

      // If checkin but no check out
      if (this.checkIn && !this.checkOut) {
        this.addCheckOut(this.checkIn, date);
      }

      // If no dates selected
      if (!this.checkIn && !this.checkOut) {
        this.addCheckIn(date);
      }
    } finally {
      log.debug(
        'checkIn',
        this.checkIn ? this.checkIn.toString() : 'undefined'
      );
      log.debug(
        'checkOut',
        this.checkOut ? this.checkOut.toString() : 'undefined'
      );
      Log.groupEnd();
    }
  };
}
